unit GAS.Enumerations;

interface
{$IFDEF SPHINX_SERVER}
{$DEFINE MAP_ENUMS}
{$ENDIF}

{$IFDEF REGISTER_ENTITIES}
{$DEFINE MAP_ENUMS}
{$ENDIF}

{$IFDEF MAP_ENUMS}
uses
  Aurelius.Mapping.Attributes;
{$ENDIF}

{$SCOPEDENUMS ON}

type

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'None,FixedFee,Percentage')]{$ENDIF}
  TLicenseType = (None, FixedFee, Percentage);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'None,Monthly,Annual')]{$ENDIF}
  TFixedFeePeriod = (None, Monthly, Annual);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'Pending,Trial,Active,Suspended,Deleted,Admin')]{$ENDIF}
  TOrganisationStatus = (
    /// <summary>
    /// Initial setup in process
    /// </summary>
    Pending, Trial,
    /// <summary>
    /// Available
    /// </summary>
    Active, Suspended,
    /// <summary>
    /// No longer exists
    /// </summary>
    Deleted, Admin);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'Unknown,Standard,ManagedTenant,Agent,Admin')]{$ENDIF}
  TOrganisationKind = (Unknown,
    /// <summary>
    ///   a single charity
    /// </summary>
    Standard,
    /// <summary>
    ///  A standard tenant being managed by an agent. Differentiated for
    ///  the billing process
    /// </summary>
    ManagedTenant,
    /// <summary>
    ///   an organisation that administers mulitple single charities (standard)
    /// </summary>
    Agent,
    /// <summary>
    ///   GiftAider - can manage access all Agents and single charities
    /// </summary>
    Admin);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString,
      'System,Pending,Inactive,Active,Left,Retired,Suspended,Deleted,NotExists,Deceased')]{$ENDIF}
  TUserStatus = (System, Pending, Inactive, Active, Left, Retired, Suspended, Deleted, NotExists, Deceased);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'App,Email,SMS')]{$ENDIF}
  TMFAPreference = (App, Email, SMS);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'AsAgent,AsCharity')]{$ENDIF}
  /// <summary>
  ///   Defines how submission from an Agent should be handled
  /// </summary>
  /// <remarks>
  ///   There are 2 types of Agent in GiftAider:<list type="bullet">
  ///     <item>
  ///       an Agent as recognised as such by HMRC
  ///     </item>
  ///     <item>
  ///       an Organisation that manages GiftAid on behalf of a chatity but submits as that charity
  ///     </item>
  ///   </list>
  ///   This affects how the Submission XML is built
  /// </remarks>
  TAgentSubmissionType = (
    /// <summary>
    ///   an HMRC recognised Agent
    /// </summary>
    AsAgent,
    /// <summary>
    ///   a Charity management organisation
    /// </summary>
    AsCharity);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'Web,Server,Desktop,Mobile,Utility,API')]{$ENDIF}
  TClientApplicationType = (Web, Server, Desktop, Mobile, Utility, API);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'PendingApproval,Active,Suspended,Closed')]{$ENDIF}
  TClientApplicationStatus = (PendingApproval, Active, Suspended, Closed);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'Development,Sandbox,Live')]{$ENDIF}
  TClientApplicationTarget = (Development, Sandbox, Live);

{$IFDEF MAP_ENUMS} [Enumeration(TEnumMappingType.emString, 'Active,Expired,InActive')]{$ENDIF}
  TDeclarationStatus = (Active, Expired, InActive);

const
  ORGANISATION_EDITION_STANDARD = 'Standard';
  ORGANISATION_EDITION_CRM = 'CRM';

  CRM_None = 0;
  CRM_Basic = 1;
  CRM_Advanced = 3;
  CRM_Enterprise = 5;


implementation

{$SCOPEDENUMS OFF}

end.

